module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6dleb"))).then(() => parcelRequire('fThBo'));